import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { userLoginStart } from '../../store/redux-slices/login'
import { getItem, getLoginToken } from '../../utils/storageUtils'
import { closeModal } from 'store/redux-slices/modal'
import { MODALS } from 'constants/modals'

const useUserLogin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { languageCode } = useParams()
  const { loading } = useSelector(state => state.login)
  const { languages, languageData, selectedLanguageCode } = useSelector((state) => state.language)
  const location = useLocation()
  const state = location?.state
  const [showModal, setShowModal] = useState({
    show: false,
    expiration: ''
  })
  const [showResendEmail, setShowResendEmail] = useState(false)
  const [language, setLanguage] = useState(languageCode || selectedLanguageCode || getItem('language'))

  const isUserBlock = useSelector((state) => state.user?.isUserBlock)
  const modalBasedAuth = useSelector(state => state?.uiConfig?.general?.modalBasedAuth)

  useEffect(() => {
    if (getLoginToken()) {
      navigate('/')
    }
  }, [])

  const handleSignIn = ({ email, password }) => {
    const returnTo = window.locationPath || state?.navigate || (modalBasedAuth ? location.pathname : '/')
    dispatch(userLoginStart({ email, password, setShowModal, navigate, returnTo, setShowResendEmail, callBack: () => dispatch(closeModal(MODALS.AUTH)) }))
  }

  return {
    loading,
    showModal,
    showResendEmail,
    languageData,
    languages,
    language,
    setLanguage,
    setShowModal,
    handleSignIn,
    isUserBlock
  }
}

export default useUserLogin
